import { CircularProgress, Container, Paper, Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { CasUserContext } from "../../services/casUserContext";
import { UnauthorizedPage } from "../Error/ErrorUnauthorized";
import UsuarioService from "../../services/UsuarioService";
import EventoService from "../../services/EventoService";
import { EvntHistorialProyectoDTO } from "../../interfaces/ProyectosDTOS/EvntHistorialProyectoDTO";
import EventosHistorialTable from "../../componentes/Proyectos/HistorialUserTable";
import { RiChatHistoryLine } from "react-icons/ri";

const usuarioService = new UsuarioService();
const eventoService = new EventoService();

export const HistorialEventPage:React.FC<{}> =() =>{
    const casUserContext = useContext(CasUserContext);
    const userData = casUserContext.userData;
    const [auth,setAuth] = useState(true);
    const [ready,setReady] = useState(false);
    const [historial,setHistorial] = useState<Array<EvntHistorialProyectoDTO>>([]);
    //#region funciones
    const fetchData = async () =>{
        try{
            await eventoService.GetEventosByIdInvestigador(userData.idinv,userData.token)
            .then((data) => {
               //console.log(data.listData);
               if(data.status.isSuccessfully){
                setHistorial(data.listData)
                setReady(true);                
               }else{
                setHistorial([]);
                setReady(true);                
               }
            })               
            .catch((error) => console.error(error));
       }catch(error){
         console.error('Error:',error);
       }
    }
    //#endregion
    //#region Seccion Carga
    useEffect(() => {
        const flag = usuarioService.authorizedByRol(142,userData.roles) || usuarioService.authorizedByRol(144,userData.roles);
        setAuth(flag);
    },[userData]);

    useEffect(() => {
        if(auth){
            fetchData();
        }
    },[userData]);
    //#endregion
    return(
        <Container sx={{mt:4}}>
            {auth ? 
            ready ? 
            <Paper sx={{ p: 3 }} elevation={2}>
                <Typography variant="h5" gutterBottom>
                    <RiChatHistoryLine/> Eventos Proyectos
                </Typography>
                <EventosHistorialTable rowsPerPage={[5 ,10, 25, 100]} data={historial} /> 
            </Paper>
            :
            <Stack sx={{ width: '100%' }} spacing={2}>
                <CircularProgress color="secondary" />
            </Stack>
            :
            <UnauthorizedPage />
            }
        </Container>
        
    );
}